import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowUpRight, KeyRound, Wallet } from 'lucide-react';
import { PageHeader } from '../components/ui';
import { ReadState } from '../components/ReadState';
import { useConsole } from '../state/ConsoleProvider';
import { useReadResource, usd } from '../lib/live';
import { publicWebsiteUrl } from '../lib/config';

export default function Overview() {
  const { api, account } = useConsole();
  const loadWallet = useCallback(() => api.getWallet(), [api]);
  const wallet = useReadResource(loadWallet, 'Your balance could not be loaded. Try again.');
  if (!account) return null;

  return <>
    <PageHeader eyebrow="YOUR ROTEN ACCOUNT" title="Overview" description="Your balance, API keys, and usage in one place." actions={<Link className="button button-primary" to="/api-keys"><KeyRound size={16} />Manage API keys</Link>} />
    <section className="panel management-balance-card live-overview-balance" aria-labelledby="overview-balance-heading">
      <div className="management-balance-top"><span id="overview-balance-heading"><Wallet size={16} />Available balance</span></div>
      <ReadState {...wallet} label="Loading balance…" />
      {wallet.data && <><div className="management-balance-value live-money">{usd(wallet.data.balance)}</div><p>Your balance pays for Roten API usage.</p></>}
      <div className="management-balance-footer"><Link className="text-link" to="/billing">View billing <ArrowUpRight size={14} /></Link><button className="button button-ghost" disabled={wallet.loading} onClick={wallet.retry}>Refresh balance</button></div>
    </section>

    <div className="live-link-grid">
      <Link className="panel live-link-card" to="/api-keys"><KeyRound size={21} /><h2>API keys</h2><p>Create keys for your applications and revoke keys you no longer use.</p><span className="text-link">Manage keys <ArrowUpRight size={14} /></span></Link>
      <Link className="panel live-link-card" to="/usage"><Activity size={21} /><h2>Usage</h2><p>Review consumption history and filter by date, model, or API key name.</p><span className="text-link">View usage <ArrowUpRight size={14} /></span></Link>
      <a className="panel live-link-card" href={`${publicWebsiteUrl}/docs`} target="_blank" rel="noreferrer"><ArrowUpRight size={21} /><h2>Documentation</h2><p>Connect your application to Roten and send your first request.</p><span className="text-link">Read the docs <ArrowUpRight size={14} /></span></a>
    </div>
  </>;
}
